import { HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
// import { OptimaAPPServer2Service, CacheValidationService, OptimaAPIHeaderService, StateStore, ItxnRelationshipLog, iLocalStorageConfig, CachedDataCategories, OptimaAPIs, getBlankAPIEndPoint, sortEntity, IBizEntityType, OptimaAPIHeaderValues } from "@optima-stride-ai/core";
import { LocalStorageService, OptimaAPPServer2Service, OptimaAPIHeaderService, StateStore, CachedDataCategories, CacheValidationService, iLocalStorageConfig, OptimaAPIs, getBlankAPIEndPoint, JsonLoaderService } from '@optima-stride-ai/optima-platform';
import { convertIdArrayToQueryString, getAvatarUrlFromEmail } from "../../state/state-utils/utility";
import { BizEntityStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { benzaitenAppHeaders, benzaitenAppServerURL } from "../../environments/environment";
import { BizEntityTypeStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { ProgressIndicatorService } from "@optima-stride-ai/optima-platform";
import { IBizEntityType, ItxnRelationshipLog, sortEntity } from "@optima-stride-ai/core";

@Injectable({
  providedIn: 'root'
})
export class TxnLogStateStoreService {
  private optimaAppServerService = inject(OptimaAPPServer2Service);

  private localStorageService = inject(LocalStorageService);
  private cacheInvalidationService = inject(CacheValidationService);
  private jsonLoaderService :JsonLoaderService = inject(JsonLoaderService);
  private progressIndicatorService :ProgressIndicatorService = inject(ProgressIndicatorService);
  private optimaAPIs = inject(OptimaAPIs);
  private optimaAPIHeaderService = inject(OptimaAPIHeaderService);
  private txnLogsStore: StateStore<ItxnRelationshipLog[]> | undefined;
  private txnLogSingleStore: StateStore<ItxnRelationshipLog> | undefined;

  // private appServerURL = benzaitenAppServerURL;
  // private appHeaders = benzaitenAppHeaders;
  
  // private readonly apiHeaders : OptimaAPIHeaderValues = new OptimaAPIHeaderValues(this.appHeaders.tenantuuid, this.appHeaders.appid, this.appHeaders.userToken);
  
  showDebugMessages = false;

  private _dealWithDataLocally = false; //API will not be called, data will be generated locally from the mock data (if the shape of data is not in sync (server/local/app-logic), this might fail)

  constructor() {
    this.initialSetup();
  }

  set dealWithDataLocally(value: boolean) { this._dealWithDataLocally = value; }


  private initialSetup() {
    let localStoreConfig: iLocalStorageConfig = {
      localStorageService: this.localStorageService,
      discardLocalData: !this._dealWithDataLocally,
      // key: MockRemoteAPIStorageKeys.TxnLogs,
      initialMockDataJSONAssetRelativePath: 'data/static/startup/test-tenant-two/txn-log-mock-data.json',
    };
    // this.optimaAPIHeaderService.optimaAPIHeaderValues = this.apiHeaders;
    this.txnLogsStore = new StateStore<ItxnRelationshipLog[]>(CachedDataCategories.All, this.optimaAppServerService, localStoreConfig, this.cacheInvalidationService, this.jsonLoaderService, (data) => { return true; },this.optimaAPIHeaderService, txnLogAPIDataTransformer, this.progressIndicatorService, true);
    this.txnLogsStore.showDebugMessages = this.showDebugMessages;
  }

  get changed() {
    return this.txnLogsStore?.changed;
  }

  getState( bizEntityStateStoreService?: BizEntityStateStoreService, bizEntityTypeStateStoreService?: BizEntityTypeStateStoreService, bizEntityId?:string, limit?: number, offset?: number) {
    // const authHeader = getBearerTokenHeader(userService.authToken?.token);
    // if (!authHeader) throw new Error("No auth header found");

    if (!this.txnLogsStore) throw new Error("Store not initialized");

    
    if (this._dealWithDataLocally) {
      return this.txnLogsStore.getState()
    } else {
    return new Promise<ItxnRelationshipLog[]>((resolve, reject) => {
      this.txnLogsStore?.getState(
        {
          authRequired: true,
          apiEndPoint: this.optimaAPIs.txnLog,
          apiParams: new HttpParams(
            {
              fromString : bizEntityId ? convertIdArrayToQueryString([bizEntityId], undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, limit, offset) : ''
            }
          ),
          fullURLWithParams: '',
          method: 'GET',
          headers: [],
          body: undefined
        }, "").then((data) => {
          if (data) {
            if(bizEntityStateStoreService){
              this.mapRelationEntity(data, bizEntityStateStoreService, bizEntityTypeStateStoreService).then((data) => {
                populateLogFieldValues(data);
                resolve(data);
              }).catch((error) => {
                reject(error);
              });
            } else{
              resolve(data);
            }
          } else {
            resolve([]);
          }
        }).catch((error) => {
          reject(error);
        });
    })};
  }

  mapRelationEntity(data:any[], bizEntityStateStoreService: BizEntityStateStoreService, bizEntityTypeStateStoreService?:BizEntityTypeStateStoreService): Promise<any>{
    return bizEntityStateStoreService.getState(bizEntityTypeStateStoreService).then((bizEntity) => {
      if(!bizEntity) return new Promise<any>((resolve, reject) => {
        reject("No BizEntity found");
      });
      
      data.forEach((entity) => {
        entity.bizEntity = bizEntity.find((type) => type.id === entity.bizEntityId);
      });

      return new Promise<any>((resolve, reject) => {
        resolve(data);
      });
    });
  }
  create(entity: ItxnRelationshipLog): Promise<any> | undefined {

    // const authHeader = getBearerTokenHeader(userService.authToken?.token);
    // if (!authHeader) throw new Error("No auth header found");

    entity = txnLogDataSyncBeforeSendingToAPI(entity);

    return this.txnLogsStore?.create(
      {
        authRequired: true,
        apiEndPoint: this._dealWithDataLocally ? getBlankAPIEndPoint() : this.optimaAPIs.txnLog,
        apiParams: new HttpParams(),
        fullURLWithParams: '', //currently not used in the service. So from where key is determined. See above when store created config was given.
        method: 'POST', //currently not in use
        headers: [],
        body: entity
      }, "[Add Item-1]", true
    );
  }

  update(entity: ItxnRelationshipLog, localOnly: boolean = false): Promise<any> | undefined {
    // const authHeader = getBearerTokenHeader(userService.authToken?.token);
    // if (!authHeader) throw new Error("No auth header found");
    return this.txnLogsStore?.updateRemote(
      {
        authRequired: true,
        apiEndPoint: this._dealWithDataLocally ? getBlankAPIEndPoint() : this.optimaAPIs.txnLog,
        apiParams: new HttpParams(),
        fullURLWithParams: '', //currently not used in the service. So from where key is determined. See above when store created config was given.
        method: 'PUT', //currently not in use
        headers: [],
        body: entity
      }, "[EditItem-1]", true
    );
  }
}

export function txnLogDataSyncBeforeSendingToAPI(txnLog: any) : any{
 
    if(txnLog.hasOwnProperty('logFieldValues'))
    {
      txnLog.metaFieldValues = txnLog.logFieldValues.reduce((acc :any, curr: any) => {
        acc[curr.key] = curr.value;
        return acc;
      }, {});
    }
    if(txnLog.hasOwnProperty('bizEntity'))
    {
      txnLog.bizEntityId = txnLog.bizEntity.id;
      delete txnLog.bizEntity;
    }

    if(txnLog.hasOwnProperty('bizEntityId')){
      txnLog.bizEntityTxnId = txnLog.bizEntityId;
      delete txnLog.bizEntityId;
    }

    if(!txnLog.hasOwnProperty('duration')){
      txnLog.duration = {
        from: new Date(),
        to: new Date()
      }
    }

    if(!txnLog.hasOwnProperty('isActive'))
    {
      txnLog.isActive = true;
    }
    // console.log(txnLog);
    return txnLog;
}

//ToDo
//To be redone. Temporary arrangement till Client and API are in sync.
export function txnLogAPIDataTransformer(data: any): ItxnRelationshipLog[] {
  if (data) {
    data = data.map((item: any) => {
     
     
      if(item.hasOwnProperty('datetime'))
      {
        item.date = item.datetime;
        delete item.datetime;
      }
      
     if(!item.hasOwnProperty('author')){
      item.author = {
        avatar: getAvatarUrlFromEmail(item.createdBy)
      }
     }

      return item;
    });
  }
  data = sortEntity(data,'date',false);
  return data;
}

function populateLogFieldValues(data:any){
  if(data && data.length > 0){
    data.forEach((item:any) => {
      let bizEntityType:IBizEntityType = item.bizEntity.type;
      if(bizEntityType && bizEntityType.txnLogAdditionalField){
        item.logFieldValues = [];
        for(const bizEntityFieldMeta of bizEntityType.txnLogAdditionalField){
          let fieldValue = item.metaFieldValues[bizEntityFieldMeta.name];
          item.logFieldValues.push({key:bizEntityFieldMeta.name, value:fieldValue, fieldMeta: bizEntityFieldMeta});
        }
      }
    });
   
  }
}